import { render, staticRenderFns } from "./noDataImg.vue?vue&type=template&id=5ed590b2"
import script from "./noDataImg.vue?vue&type=script&lang=js"
export * from "./noDataImg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports